import { FlexBox, ThumbnailLayout } from '@airship-platform/jam-web/components';
import { BoxIcon } from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';

interface LinkedItemsProps {
  linkedItems: {
    pricebookId: string;
    type: 'EQUIPMENT' | 'MATERIAL';
  }[];
  products: {
    pricebookId: string;
    name: string;
    model: string;
    images: { url?: string; type: string; assetKey: string }[];
    groupingName: 'SYSTEM' | 'ADDONS' | 'UPGRADES' | 'LINKED_ITEM';
    quantity: number;
  }[];
}

const LinkedItems: React.FC<LinkedItemsProps> = ({ linkedItems, products }) => {
  const filteredProducts = products.filter(
    (p) => p.groupingName === 'LINKED_ITEM'
  );

  const filteredLinkedItems = linkedItems.flatMap((li) =>
    filteredProducts.filter((p) => p.pricebookId === li.pricebookId)
  );

  if (!filteredLinkedItems.length) {
    return null;
  }

  return (
    <FlexBox flexDirection="column" gap={2}>
      <Typography variant="h4">
        Linked Items ({filteredLinkedItems.length})
      </Typography>
      <FlexBox flexDirection="column" gap={2}>
        {filteredLinkedItems.map((item) => {
          const imageUrl = item.images
            .filter((i) => i.type === 'Image')
            .map((i) => i.url)
            .find(Boolean);

          return (
            <ThumbnailLayout
              key={item.pricebookId}
              imageUrl={imageUrl}
              imageAlt={item.name}
              fallback={<BoxIcon />}
              imageProps={{
                width: '3rem',
                height: '3rem',
                minWidth: '3rem',
              }}
            >
              <FlexBox flexDirection="column" gap={0.5} flex={1}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {item.name}
                </Typography>
                {item.model && (
                  <Typography variant="body2" color="text.secondary">
                    Model: {item.model}
                  </Typography>
                )}
                <Typography variant="body2" color="text.secondary">
                  Quantity: {item.quantity}
                </Typography>
              </FlexBox>
            </ThumbnailLayout>
          );
        })}
      </FlexBox>
    </FlexBox>
  );
};

export default LinkedItems;
